import { IFormViewForm } from 'components/FormView';

const MovementDetails: IFormViewForm = {
  id: 'MovementDetails',
  layout: {
    rows: 2,
    columns: 2
  },
  fields: [
    {
      id: 1,
      position: {
        row: 1,
        col: 1
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 1,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Movement',
            name: 'Movement',
            placeholder: '',
            size: 'medium',
            disabled: true,
            required: false,
          }
        },
        {
          id: 0,
          type: 'EXTENDED_TEXT_FIELD',
          props: {
            label: 'Quantity',
            name: 'Quantity',
            size: 'small',
            disabled: true,
          }
        },
        {
          id: 2,
          type: 'EXTENDED_TEXT_FIELD',
          visible: true,
          props: {
            label: 'Quantity balance',
            name: 'BalanceDisplay',
            placeholder: '',
            size: 'small',
            disabled: true,
            required: false,
          }
        },
        {
          id: 3,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Cost each',
            name: 'CostEachDisplay',
            placeholder: '',
            size: 'medium',
            disabled: true,
            required: false,
          }
        },
        {
          id: 4,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Total count',
            name: 'CostTotalDisplay',
            placeholder: '',
            size: 'medium',
            disabled: true,
            required: false,
          }
        },
      ]
    },
    {
      id: 1,
      position: {
        row: 1,
        col: 2
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 4,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Sell price each',
            name: 'PriceEachDisplay',
            size: 'medium',
            disabled: true,
          }
        },
        {
          id: 4,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Tax each',
            name: 'TaxEach',
            size: 'medium',
            disabled: true,
          }
        },
        {
          id: 4,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Total price',
            name: 'PriceTotalDisplay',
            size: 'medium',
            disabled: true,
          }
        },
      ]
    },
    {
      id: 1,
      position: {
        row: 2,
        col: 1,
        colspan: 2
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 6,
          type: 'TEXT_AREA',
          props: {
            label: 'Comment',
            name: 'Comment',
            size: 'large',
            disabled: true,
            style: {
              'height': '400px',
              '& label': {
                paddingTop: 0,
              }
            },
          }
        }
      ]
    },
  ]
};

export default MovementDetails;
